import Shuffle from './Shuffle';

export default Shuffle;
